export const CenterLayout = ({ children }) => (
  <div className="flex flex-1 justify-center mt-10">{children}</div>
);
